import React from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
export default function ChangePassword() {


    const changepswFormik = useFormik({
        enableReinitialize: true,
        initialValues: {

            oldpassword: "",
            newpassword: "",
            renewpassword: "",
        },
        validationSchema: Yup.object({
            oldpassword: Yup.string()
                .required('Old password is required')
                .min(8, 'Password must be at least 8 characters'),
            newpassword: Yup.string()
                .required('New password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(/[0-9]/, 'Password must contain at least one numeric character')
                .matches(/[a-zA-Z]/, 'Password must contain at least one alphabetic character')
                .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'Password must contain at least one lowercase letter'),
            renewpassword: Yup.string()
                .required('Confirm new password is required')
                .oneOf([Yup.ref('newpassword')], 'New Password must match with Retype Password')
        }),
        onSubmit: (values) => {
        }
    })






    return (
        <>

            <CommonFormHeading heading="Change Password" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>
                <FormikProvider value={changepswFormik}>

                    <Form onChange={changepswFormik?.handleChange} onSubmit={changepswFormik?.handleSubmit} className="form_adjust" >

                        <bie.Row className="px-2 pt-3 mb-3" style={{ border: '0.2px solid black' }}>
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                    <span className='field-mandatory' >Old Password</span>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                    <Field type="text" name="oldpassword" className="form-control" />
                                    <ErrorMessage name="oldpassword" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                    <span className='field-mandatory'>New Password</span>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>

                                    <Field type='text' name="newpassword" className='form-control' />
                                    <ErrorMessage name="newpassword" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                    <span className='field-mandatory'>Retype New Password</span>
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>

                                    <Field type='text' name="renewpassword" className='form-control' />
                                    <ErrorMessage name="renewpassword" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>


                            <div>
                                <ul>
                                    <li>Password must be at least 8 characters.</li>
                                    <li>Must have at least one numeric, one alphabet, and one special character.</li>
                                    <li>Must have at least one uppercase and one lowercase character.</li>
                                </ul>
                            </div>
                            <div className="d-flex flex-row justify-content-end pb-4">

                                <button type="submit" className="btn btn-secondary btn-sm rounded" >
                                    Reset Password
                                </button> &emsp;

                                <button type="button" className="btn btn-success btn-sm rounded" onClick={() => {
                                    changepswFormik.setFieldValue("oldpassword", "")
                                    changepswFormik.setFieldValue("newpassword", "")
                                    changepswFormik.setFieldValue("renewpassword", "")

                                }}>
                                    Clear
                                </button>
                            </div>
                        </bie.Row>
                    </Form>

                </FormikProvider>
            </bie.Container>



        </>
    )
}
